module.exports = __webpack_public_path__ + "static/media/mvptimer.310c8573.png";